<script>
    import { onMount } from "svelte/internal";
    import debounce from "lodash/debounce";
    import { SEARCH } from "../../Utils/utilConstants.svelte";
    import { DateInput } from "./index.svelte";
    import { v4 } from "uuid";
    import DecimalInput from "./DecimalInput.svelte";
    import CustomTooltip from "./CustomTooltip.svelte";

    export let type = "text";
    export let title = "";
    export let id = "";
    export let inputClass = "";
    export let titleClass = "";
    export let placeholder = "";
    export let value = "";
    export let isLong = false;
    export let isDisable = false;
    export let inputFunc = () => {};
    export let minDate = "";
    export let maxDate = "";
    export let stepAmount = 0.01;
    export let minAmount = 0;
    export let maxAmount;
    export let refreshDateInputValue;
    export let showTimeInputClearButton = true;
    export let info = '';

    export let minYear,
        maxYear,
        showScrollYearOptions = false,
        yearOptionSize;

    let defaultClass = isLong
        ? "input-sm w-48 bg-gray-200"
        : "input-sm w-32 bg-gray-200";
    let defaultTitleClass = "text-[11px] font-[500]";

    const uuid = v4();

    $: inputId = id ? id : uuid;

    onMount(() => {
        const numberInput = document.querySelectorAll(".numberInput");
        numberInput.forEach((input) => {
            input.addEventListener("keypress", (e) => {
                if (
                    !(
                        (e.keyCode > 95 && e.keyCode < 106) ||
                        (e.keyCode > 45 && e.keyCode < 58) ||
                        e.keyCode == 8
                    )
                ) {
                    e.preventDefault();
                    return false;
                }
            });
        });
    });

    const onNumberInputKeyDown = (e) => {
        const { key } = e;
        const allowedKeyCode = [
            "Backspace",
            "Delete",
            "ArrowLeft",
            "ArrowRight",
            "ArrowUp",
            "ArrowDown",
            "Tab",
        ];

        const allowedControlActionKeys = ["a", "A", "c", "C", "x", "X"];

        if (
            (key.length === 1 &&
                key.match(/^[0-9]+$/) &&
                !e.ctrlKey &&
                !e.shiftKey &&
                !e.metaKey) ||
            allowedKeyCode.includes(key) ||
            (allowedControlActionKeys.includes(key) && (e.ctrlKey || e.metaKey))
        )
            return true;

        if (
            ((e.ctrlKey || e.metaKey) && (key === "v" || key === "V")) ||
            (e.shiftKey && key === "Insert")
        ) {
            setTimeout(() => {
                try {
                    const filteredValue = Number(value.replace(/\D/g, ""));
                    value = filteredValue ? filteredValue : "";
                } catch (error) {
                    value = "";
                }
                handleInput();
            }, 100);
            return true;
        }

        return e.preventDefault();
    };

    const handleInput = debounce(() => {
        inputFunc();
    }, SEARCH.DEBOUNCE_TIME);
</script>

<div class="flex flex-col">
    <p class={defaultTitleClass + " " + titleClass}>
         {#if info}
            <CustomTooltip tooltipPosition="top">
                <div class="cursor-pointer border rounded-full" slot="tooltipTrigger">
                    <i
                        class="fa-solid fa-circle-info"
                    >
                    </i>
                </div>
               
                <p>{info}</p>
            </CustomTooltip>
         {/if}
        {title}
    </p>
   
    {#if type === "number"}
        <input
            type="text"
            class={defaultClass + " " + inputClass + " numberInput"}
            {placeholder}
            bind:value
            on:mousewheel|preventDefault={() => {
                true;
            }}
            on:input={handleInput}
            disabled={isDisable}
            id={inputId}
            on:paste={(e) => {
                const pasteData = e.clipboardData.getData("text");
                const sanitizedData = pasteData.replace(/\D/g, "");
                e.preventDefault();

                if (sanitizedData) {
                    value = Number(sanitizedData);
                    inputFunc();
                }
            }}
        />
        <!-- on:keydown={(e) => onNumberInputKeyDown(e)} -->
    {:else if type === "password"}
        <input
            type="password"
            class={defaultClass + " " + inputClass}
            {placeholder}
            bind:value
            on:input|preventDefault={handleInput}
            disabled={isDisable}
            autocomplete="off"
            id={inputId}
        />
    {:else if type === "email"}
        <input
            type="email"
            class={defaultClass + " " + inputClass}
            {placeholder}
            bind:value
            on:input|preventDefault={handleInput}
            disabled={isDisable}
            id={inputId}
        />
    {:else if type === "date"}
        <!-- {#if isDisable}
            <input
                type="date"
                class={defaultClass + " " + inputClass}
                {placeholder}
                bind:value
                on:input|preventDefault={handleInput}
                disabled={isDisable}
                min={minDate}
                max={maxDate}
                id={inputId}
            />
        {:else} -->
        <DateInput
            bind:value
            wrapperClass={defaultClass + " " + inputClass}
            showClearButton={showTimeInputClearButton}
            {minDate}
            {maxDate}
            {isDisable}
            {placeholder}
            id={inputId}
            on:change={handleInput}
            bind:refreshValue={refreshDateInputValue}
            {minYear}
            {maxYear}
            {showScrollYearOptions}
            {yearOptionSize}
        />
        <!-- {/if} -->
    {:else if type == "amount"}
        <DecimalInput
            bind:value
            inputStep={stepAmount}
            inputMin={minAmount}
            inputMax={maxAmount}
            inputPlaceholder={placeholder}
            inputFunc={handleInput}
            isDisabled={isDisable}
            inputClass={defaultClass +
                " " +
                inputClass +
                " numberInput border-0 border-b-2 rounded-none border-[#818e9b] focus:border-[#270053] focus:outline-none"}
        />
    {:else}
        <input
            type="text"
            class={defaultClass + " " + inputClass}
            {placeholder}
            bind:value
            on:input|preventDefault={handleInput}
            disabled={isDisable}
            id={inputId}
        />
    {/if}
</div>

<style>
    p {
        color: #6f726c;
    }

    input {
        outline: 0;
        border-width: 0 0 2px;
        border-color: #818e9b;
        color: #270053;
    }

    input:focus {
        border-color: #270053;
    }
</style>
